import { Station } from '../../../../types/azk-binding.types';

import './StationsTable.css';
import { StationsTableProps } from './StationsTable.types';

/**
 * Stations table component displaying station data in a sortable table format
 * Supports both desktop and mobile layouts with different column visibility
 *
 * Features:
 * - Sortable columns with visual sort indicators
 * - Double-click to open station profile
 * - Brand badges with different styling for OKKO vs competitors
 * - Details button for explicit profile access
 * - Mobile-responsive header (shown only on mobile)
 * - Unicode, province, brand, address, and station number columns
 *
 * @param props - Component props containing station data and interaction callbacks
 * @returns JSX element containing the complete stations table
 */
export function StationsTable({ isMobile, stations, onStationClick }: StationsTableProps) {
  return (
    <table key={stations.length} className={`azk-list-table ${isMobile ? 'mobile-table' : ''}`}>
      <tbody>
        {stations.map((station: Station, index: number) => (
          <tr
            key={station.unicode || index}
            className="azk-list-table-row"
            onDoubleClick={() => onStationClick(station)}
          >
            <td className="azk-list-table-cell azk-list-table-cell-unicode">{station.unicode}</td>
            <td className="azk-list-table-cell azk-list-table-cell-province">{station.province}</td>
            <td className="azk-list-table-cell azk-list-table-cell-brand">
              <span className={`azk-list-brand-badge ${station.brand === 'ОККО' ? 'okko' : 'other'}`}>
                {station.brand}
              </span>
            </td>
            <td className="azk-list-table-cell azk-list-table-cell-address">{station.address}</td>
            <td className="azk-list-table-cell azk-list-table-cell-station-number">{station.station_number}</td>
            <td className="azk-list-table-cell azk-list-table-cell-actions">
              <button
                className="azk-list-details-button"
                onClick={(e: any) => {
                  e.stopPropagation();
                  onStationClick(station);
                }}
              >
                Детальніше
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
